var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconCheck = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.56 6.44a1.502 1.502 0 0 1 0 2.122L11.562 20.561a1.502 1.502 0 0 1-2.124 0l-5.999-6a1.502 1.502 0 0 1 2.123-2.123l4.94 4.936 10.94-10.935a1.502 1.502 0 0 1 2.122 0h-.004z",
    fill: "#1A202C",
    fillRule: "nonzero"
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconCheck, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-check.a002bb67.svg";
export { ForwardRef as ReactComponent };